var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { AbortableNavigateEventListener, ClickEventListener, CollapseEventListener, NavigateEventListener, PageEventListener, RenderEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class TimelineAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /* @event */
        this.onAfterNavigate = new NavigateEventListener();
        /** @event */
        this.onClick = new ClickEventListener();
        /** @event */
        this.onContextMenuClick = new ClickEventListener();
        /** @event */
        this.onDoubleClick = new ClickEventListener();
        /** @event */
        this.onCollapse = new CollapseEventListener();
        /** @event */
        this.onNavigate = new AbortableNavigateEventListener();
        /** @event */
        this.onNextPage = new PageEventListener();
        /** @event */
        this.onPrevPage = new PageEventListener();
        /** @event */
        this.onDynamicContentRender = new RenderEventListener();
    }
    /**
     * Checks if the interval option is enabled.
     */
    hasIntervalOption() {
        return this.state.intervalOption;
    }
    /**
     * Sets the interval option property.
     *
     * @param intervalOption - The new value for the property.
     */
    setIntervalOption(intervalOption) {
        this.setState({ intervalOption });
    }
    /**
     * Gets the data property.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the data property.
     *
     * @param data - The timeline events.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Gets the group by property.
     */
    getGroupBy() {
        return this.state.groupBy;
    }
    /**
     * Sets the group by property.
     *
     * @param groupBy - The property to group by.
     */
    setGroupBy(groupBy) {
        this.setState({ groupBy });
    }
    /**
     * Gets the initial interval property.
     */
    getInitialInterval() {
        return this.state.initialInterval;
    }
    /**
     * Sets the initial interval property.
     *
     * @param initialInterval - The initial interval.
     */
    setInitialInterval(initialInterval) {
        this.setState({ initialInterval });
    }
    /**
     * Gets the interval property.
     */
    getInterval() {
        return this.state.interval;
    }
    /**
     * Sets the interval property.
     *
     * @param interval - The interval value.
     */
    setInterval(interval) {
        this.setState({ interval });
    }
    // Just to comply with the collapsible interface.
    isCollapsed() {
        return false;
    }
    // @ts-ignore: Just to comply with the Collapsible interface
    setCollapsed(value) {
        return;
    }
    /**
     * Gets the ungrouped title expression.
     */
    getUngroupedTitle() {
        return this.state.ungroupedTitle;
    }
    /**
     * Sets the ungrouped title expression.
     *
     * @param ungroupedTitle - The ungrouped title expression.
     */
    setUngroupedTitle(ungroupedTitle) {
        this.setState({ ungroupedTitle });
    }
    /**
     * Gets the superscription of the timeline.
     */
    getSuperscription() {
        return this.state.superscription;
    }
    /**
     * Sets the superscription of the timeline.
     *
     * @param superscription - The superscription of the timeline.
     */
    setSuperscription(superscription) {
        this.setState({ superscription });
    }
    /**
     * Gets the superscription entry of the timeline.
     */
    getSuperscriptionEntry() {
        return this.state.superscriptionEntry;
    }
    /**
     * Sets the superscription entry of the timeline.
     *
     * @param superscriptionEntry - The superscription entry of the timeline.
     */
    setSuperscriptionEntry(superscriptionEntry) {
        this.setState({ superscriptionEntry });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onAfterNavigate", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onCollapse", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onNavigate", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onNextPage", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onPrevPage", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], TimelineAPI.prototype, "onDynamicContentRender", void 0);
export { TimelineAPI, };
//# sourceMappingURL=timeline-api.js.map